import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export const PopoverMenu = React.forwardRef(({ children }, ref) => {
  return <PopoverMenuStyles ref={ref}>{children}</PopoverMenuStyles>;
});

PopoverMenu.displayName = "PopoverMenu";
PopoverMenu.propTypes = {
  children: PropTypes.node,
};

export const PopoverMenuStyles = styled.div`
  position: absolute;
  right: -50px;
  border-radius: var(--small-border-radius);
  background: var(--gallery);

  padding-bottom: 10px;
  width: 300px;
  color: var(--text-color);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  top: 35px;

  &::after,
  &::before {
    bottom: 100%;
    content: "";
    position: absolute;
    right: 50px;
  }

  // This allows us to create an arrow for the popover
  // We also add a border by painting another arrow behind the first one
  &::after {
    border-bottom: 10px solid var(--gallery);
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    margin-left: -10px;
  }
  &::before {
    border-bottom: 11px solid var(--silver);
    border-left: 11px solid transparent;
    border-right: 11px solid transparent;
    margin-left: -11px;
  }
`;
